module.exports = __webpack_public_path__ + "static/media/castel2.0f7e838c.jpg";